<template>
<div class="mdl-grid">
  <div class="mdl-cell mdl-cell--4-col">
    <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
      <div class="mdl-tabs mdl-js-tabs">
        <div class="mdl-tabs__tab-bar ga-form-title">
          <a href="#detailsTab1" class="mdl-tabs__tab is-active">{{'newDelayed.label.details' | label}}</a>
          <a href="#faq" class="mdl-tabs__tab">{{'newDelayed.label.faq' | label}}</a>
        </div>
        <div class="mdl-tabs__panel is-active" id="detailsTab1">
          <delayed-details :tab="tab"></delayed-details>
        </div>
        <div class="mdl-tabs__panel" id="faq">
          <faq service="delayed"></faq>
        </div>
      </div>
    </div>
  </div>
  <div class="mdl-cell mdl-cell--8-col">
    <div class="card-container">
      <notification-form :model="messageModel" :init-date="initDate"></notification-form>
    </div>
    <div v-show="messageModel && messageModel.id" class="card-container">
      <div class="mdl-grid mdl-grid--nesting"  >
        <div class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp">
          <div class="ga-form-title">
            <h2 class="ga-title-text">{{'managed.label.title' | label}}</h2>
          </div>
          <div class="mdl-card__supporting-text fill">
            <data-table
              page="managed"
              :data.sync="messages"
              :selectable="table.selectable"
              :columns="table.columns"
              :sort="table.sort"
              :filter="table.filter"
              :observables="table.observables"
              >
              <div slot="actions">
                <div class="mdl-button mdl-js-button mdl-button--raised"
                v-on:click="remove()">{{ 'managed.button.delete' | label}}</div>
                <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                v-on:click="create()">{{ 'managed.button.new' | label}}</div>
              </div>
              <div slot="empty">
                <div class="empty-message">
                  {{ 'managed.label.no.messages' | label }}
                </div>
                <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                v-on:click="create()">{{ 'managed.button.new' | label}}</div>
              </div>
            </data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
var api = require('api')
var lookupValue = require('vue').filter('lookupValue')
var lookup = require('vue').filter('lookup')
var label = require('vue').filter('label')
var actions = require('common/store/actions')
var getters = require('common/store/getters')
var moment = require('moment-timezone')
var local = require('common/store/local')
module.exports = {
  ready: function () {
    // user not active yet
    if (this.user.status === 'PENDING') {
      this.$router.replace('/app/userpending')
      return
    }
    this.$dispatch('loading', true)
    if (this.user.subscription && this.user.subscription.status === 'Pending') {
      api.User.createPaymentUrl({id: this.user.id}).then((response) => {
        this.$dispatch('loading', false)
        this.$router.replace('/app/payment/' + response.data.token)
      }).catch((err) => {
        this.$dispatch('loading', false)
        this.$dispatch('show-error', err.data)
      })
      return
    }
    if (!this.user.hasMessageModel) {
      this.$dispatch('show-alert-message', 'profile.message.noMessageModel')
    } else if (!this.user.hasMessages) {
      this.$dispatch('show-alert-message', 'profile.message.noMessages')
    }
    api.MessageModel.get().then(this.set, this.onError)
    this.lang = local.get('client.language')
  },
  beforeDestroy: function () {
    this.$dispatch('dismiss-alert-message')
  },
  components: {
    dataTable: require('c/components/Table'),
    notificationForm: require('c/forms/NotificationForm'),
    delayedMessageForm: require('c/forms/DelayedMessageForm'),
    'delayed-details': require('c/segments/DelayedDetails'),
    'faq': require('c/segments/FAQ')
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  methods: {
    set: function (resp) {
      this.$dispatch('loading', false)
      // var self = this
      this.messageModel = resp.data
      if (Object.keys(this.messageModel).length === 0) {
        this.resetModel()
      }
      this.offset = moment().tz(this.user['timeZone']).utcOffset()
      this.oldValue = this.messageModel['initialDelayMessageDate']
      this.initDate = moment.parseZone(this.messageModel['nextDelayMessageDate']).add(this.offset, 'minutes').locale(this.lang).format('LLLL')
      this.messages = this.messageModel.Messages.map(function (msg) {
        msg.status = label(lookupValue(lookup('MESSAGE_STATUS'), msg.status).label)
        return msg
      })
    },
    create: function () {
      this.$router.go('/app/message/new')
    },
    remove: function () {
      var self = this

      var rows = []

      var response = null

      self.$dispatch('loading', true)
      this.messages.filter(function (row) {
        return row['__checked']
      }).forEach(function (row) {
        rows.push(api.Message.delete({id: row.id}).then(function (response) {
          var index = self.messages.indexOf(row)
          self.messages.splice(index, 1)
          return response
        }))
      })
      Promise.all(rows)
      .then(function (localResponse) {
        response = localResponse
        return self.reloadUser()
      }).then(function () {
        self.$dispatch('loading', false)
        self.$dispatch('show-success', response[0].data)
      })
      .catch(err => self.onError(err))
      self.$broadcast('clear-select')
    },
    onError: function (err) {
      this.$dispatch('loading', false)
      if (err.status !== 404) {
        this.$dispatch('show-error', err.data)
      } else {
        // first message to inizialize
        this.resetModel()
        this.offset = moment().tz(this.user['timeZone']).utcOffset()
        this.oldValue = moment().toISOString()
        this.initDate = moment.parseZone(new Date()).add(this.offset, 'minutes').locale(this.lang).format('LLLL')
        this.messageModel.initialDelayMessageDate = this.oldValue
        this.messageModel.newSendingDate = this.oldValue
        this.messageModel.newDelayMessageDate = this.oldValue
        this.messages = []
      }
    },
    resetModel: function () {
      this.messageModel = {
        id: 0,
        initialDelayMessageDate: '',
        delayMessagePeriod: '1',
        sendMessageAfter: '',
        delayMethod: '',
        additionalDelayEmail: '',
        serviceCode: '',
        phoneCode: '',
        phoneNumber: '',
        phone: '',
        newSendingDate: ''
      }
    }
  },
  events: {
    'table-clicked': function (row) {
      this.$router.go('/app/message/' + row.id)
    },
    'message-valid': function (message) {
      // var self = this
      var response = null
      this.message = message
      this.message.userId = this.user.id
      this.$dispatch('loading', true)
      api.MessageModel.update({id: this.messageModel.id}, this.message)
      .then((localResponse) => {
        response = localResponse
        return this.reloadUser()
      }).then(() => {
        this.$dispatch('loading', false)
        this.$dispatch('show-success', response.data)
        api.MessageModel.get().then(this.set, this.onError)
      }, this.onError)
    }
  },
  data: function () {
    return {
      initDate: '',
      selected: {},
      messages: [],
      messageModel: {},
      offset: 0,
      oldValue: '',
      table: {
        selectable: true,
        columns: ['recipients', 'subject'],
        sort: ['subject'],
        filter: [], // ['recipients', 'subject']
        observables: [true, false]  // true=observable
      },
      tab: '2'
    }
  }
}
</script>

<style scoped>
.mdl-card {
  min-height: 0;
}
.empty-message {
  padding-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// Manage.vue?2c9bf03c